import React from 'react';
import { BiLink } from "react-icons/bi";
import { MdAccountCircle } from "react-icons/md";
import { IoLocationSharp } from "react-icons/io5";
import { BsFillTelephoneFill } from "react-icons/bs";
import { TbMailFilled } from "react-icons/tb";
import { BiSolidPencil } from "react-icons/bi";
import { MdOutlineWork } from "react-icons/md";
import { scrollToAboutMe} from '../utils/scroll';

export default function About() {
  return (
      <article id="about-me"className='w-full h-full pb-20 relative' >
        <div className='flex flex-row justify-center pt-24 mb-28 text-6xl font-banner-font text-black cursor-pointer' onClick={scrollToAboutMe}>
          <div className='leaf-parent absolute -top-36 right-32'>
            <img className='leaf' src="https://www.demimaisons.be/themes/demimaisons/assets/images/shape-05.png" alt="Shape leaf" />
          </div>
          <BiLink  className='mr-4'/>
          <h2 className='border-b border-solid border-gray-500 pb-2 '>ABOUT ME</h2>
        </div>

        <div className='mx-auto pb-24  mt-10 w-1/2 sm:w-4/5 h-full grid grid-cols-1  sm:grid-cols-2 lg:grid-cols-3 gap-4 gap-y-20 '>
          <div className='flex w-full items-center text-2xl align-center mx-auto'>
            <MdAccountCircle  className='move-up hidden md:block text-5xl'/>
            <div className='ml-0 flex flex-col md:ml-6 align-start '>
              <p className='font-bold pb-2'>이름</p>
              <p className='text-lg '>이규영</p>
            </div>
          </div>
          <div className='flex w-full items-center text-2xl'>
            <BsFillTelephoneFill className='move-up hidden md:block text-5xl'/>
            <div className='ml-0 flex flex-col md:ml-6 align-start '>
              <p className='font-bold pb-2'>연락처</p>
              <p className='text-lg '>010-3066-6497</p>
            </div>
          </div>

          <div className='flex w-full items-center text-2xl cursor-pointer'>
            <TbMailFilled  className='move-up hidden md:block text-5xl'/>
            <a href="mailto:gylee285@gmail.com" className='ml-0 flex flex-col md:ml-6 align-start '>
              <p className='font-bold pb-2'>이메일</p>
              <p className=" text-lg">gylee285@gmail.com</p>
              {/* <p className='text-lg'>gylee285@gmail.com</p> */}
            </a>
          </div>

          <div className='flex w-full items-center text-2xl'>
            <IoLocationSharp  className='move-up hidden md:block text-5xl'/>
            <div className='ml-0 flex flex-col md:ml-6 align-start '>
              <p className='font-bold pb-2'>주소지</p>
              <p className='text-lg '>서울특별시 마포구</p>
            </div>
          </div>

          <div className='flex w-full items-center text-2xl'>
            <BiSolidPencil className='move-up hidden md:block text-5xl'/>
            <div className='ml-0 flex flex-col md:ml-6 align-start '>
              <p className='font-bold pb-2'>학력</p>
              <p className='text-base lg:text-lg mb-1'>- 캐나다 Algonquin College <br/> &nbsp;&nbsp;( 모바일 앱 디자인/개발 학과 )</p>
              <p className='text-base lg:text-lg '>- 서울여자대학교 <br/>&nbsp;&nbsp;( 불어불문학과 )</p>
            </div>
          </div>

          <div className='flex w-full items-center text-2xl'>
            <MdOutlineWork  className='move-up hidden md:block text-5xl'/>
            <div className='ml-0 flex flex-col md:ml-6 align-start  '>
              <p className='font-bold pb-2'>경력</p>
              <p className='text-base lg:text-lg mb-1'>- 에릭슨 캐나다 <br/>&nbsp;&nbsp;( UI 풀스택 개발자 )</p>
              <p className='text-base lg:text-lg'>- 캐나다 통계청 <br/>&nbsp;&nbsp;( 퍼블리싱 스페셜리스트 )</p>
            </div>
          </div>
        </div>
      </article>
  );
}

